define([
	"csi",
	"csi/_base/underscore",
	"csi/comm",
	"csi/xml"
], function(csi,_,comm,xml) {

	return {
		/** cache of role names, the format is {urlCrew: [roleName1, roleName2, ...]} */
		m_crewRolesMapping: {},

		/** global roles */
		m_globalRoles: [],

		_bAdmin: false,

		/** set global roles */
		setGlobalRoles: function(/*String[]*/globalRoles) {
			this.m_globalRoles = globalRoles;
		},

		/** determine roles the user plays in the context of given node */
		getRolesOfNode: function(/*Node?*/node) {
			return node ? this.getRolesOfCrew(xml.nodeGetCrew(node)) : this.m_globalRoles;
		},

		/** determine roles the user plays in the context of given crew */
		getRolesOfCrew: function(/*CNL?*/urlNodeCrew) {
			var roleNames = null;

			if (xml.isValidURL(urlNodeCrew)) {
				// get the list of local roles where this user belongs to
				roleNames = this.m_crewRolesMapping[urlNodeCrew];

				if (roleNames == null) {
					// request role names of the crew by request the crew itself
					// with options to return crews
					var params = {
						"Crew.Scope": "Result",
						"Fmt.Crew": "Name"
					};
					var request = comm.getNodeRequest(urlNodeCrew, params);

					var response = request.go({sync:true});
					if (response && response.isSuccessful()) {
						var crews = response.getCrews();
						if (crews) {
							if (_.isArray(crews)) {
								_.forEach(crews, function(crew) {
									this.setRolesOfCrew(crew.URL, crew.name||[]);
								}, this);
							} else {
								this.setRolesOfCrew(crews.URL, crews.name||[]);
							}

							// try to get role names again after we requested them
							roleNames = this.m_crewRolesMapping[urlNodeCrew];
						}
					}
				}
			}

			return roleNames ? this.m_globalRoles.concat(roleNames) : this.m_globalRoles;
		},

		isAdmin: function() {
			return this._bAdmin;
		},
		
		isArchiveAdmin: function(/*Node?*/node) {
			var nodeRoles = this.getRolesOfNode(node);
			return _.indexOf(nodeRoles, xml.ARCHIVE_ADMIN) >= 0;
		},
		
		isArchiveViewer: function(/*Node?*/node) {
			if (this.isArchiveAdmin(node)) {
				return true;
			}
			var nodeRoles = this.getRolesOfNode(node);
			return _.indexOf(nodeRoles, xml.ARCHIVE_VIEWER) >= 0;
		},

		/** returns 'true' if the current user is Admin or plays at least one of the passed global roles */
		isInGlobalRoles: function(/*String[]*/roles) {
			if (this._bAdmin)
				return true;
			return _.some(roles, function(r) { return (_.indexOf(this.m_globalRoles, r) >= 0); }, this);
		},

		/** returns 'true' if the current user is Admin or plays at least one of the passed node's roles */
		isInRoles: function(/*String[]*/roles, /*Node?*/node) {
			if (this._bAdmin) return true;
			var nodeRoles = this.getRolesOfNode(node);
			return _.some(roles, function(r) { return (_.indexOf(nodeRoles, r) >= 0); });
		},

		/**
		 * Checks if the current user has all the roles specified for a given node.
		 * @param {string[]} roles - An array of role names to check against the node's roles.
		 * @param {Node} [node] - The node whose roles are being checked. This parameter is optional.
		 * @returns {boolean} Returns true if the current user plays all the passed node's roles.
		 */
		isInAllRoles: function(/*String[]*/roles, /*Node?*/node) {
			if (this._bAdmin) return true;
			var nodeRoles = this.getRolesOfNode(node);
			return _.every(roles, function(r) { return (_.indexOf(nodeRoles, r) >= 0); });
		},

		setAsAdmin: function(/*Boolean*/isAdmin) {
			this._bAdmin = isAdmin;
		},

		setRolesOfCrew: function(/*CNL*/urlNodeCrew, /*String[]*/roles) {
			if (urlNodeCrew == csi.EMPTY_URL)
				this.setGlobalRoles(roles);
			else
				this.m_crewRolesMapping[urlNodeCrew] = roles;
		}
	};
});